import {InstructionsPage} from "./instructions";
import {NgModule} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {IonicPageModule} from "ionic-angular";
import {InstructionSlidesComponentModule} from '../../components/instruction-slides/instruction-slides.module';


@NgModule({
  declarations: [
   InstructionsPage,
  ],
  imports: [
    IonicPageModule.forChild(InstructionsPage),
    TranslateModule.forChild(),
    InstructionSlidesComponentModule
  ],
})
export class InstructionsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/instructions/instructions.module.ts